'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-archive.routes';

export class NewsArchiveComponent {
  constructor(NewsService, Auth, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("newsArchive");

    this.isAdmin = Auth.isAdminSync;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, 'News Archive');

    this.newsByRange = {
      "Q1-2019": [],
      "Q2-2019": [],
      "Q3-2019": [],
      "Q4-2019": [],

      "Q1-2018": [],
      "Q2-2018": [],
      "Q3-2018": [],
      "Q4-2018": [],

      "Q1-2017": [],
      "Q2-2017": [],
      "Q3-2017": [],
      "Q4-2017": [],

      "2016": [],
      "2015": [],
      "2014": [],
      "older": []
    };

    this.news = [];

    NewsService.query(data => {
      data.forEach(news => {

        if (news.validUntil) {

          if (moment(news.meta.creationDate).isBetween('2019-01-01', '2019-03-31')) {
            this.newsByRange["Q1-2019"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2019-04-01', '2019-06-30')) {
            this.newsByRange["Q2-2019"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2019-07-01', '2019-09-30')) {
            this.newsByRange["Q3-2019"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2019-10-01', '2019-12-31')) {
            this.newsByRange["Q4-2019"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2018-01-01', '2018-03-31')) {
            this.newsByRange["Q1-2018"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2018-04-01', '2018-06-30')) {
            this.newsByRange["Q2-2018"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2018-07-01', '2018-09-30')) {
            this.newsByRange["Q3-2018"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2018-10-01', '2018-12-31')) {
            this.newsByRange["Q4-2018"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2017-01-01', '2017-03-31')) {
            this.newsByRange["Q1-2017"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2017-04-01', '2017-06-30')) {
            this.newsByRange["Q2-2017"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2017-07-01', '2017-09-30')) {
            this.newsByRange["Q3-2017"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2017-10-01', '2017-12-31')) {
            this.newsByRange["Q4-2017"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2016-01-01', '2016-12-31')) {
            this.newsByRange["2016"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2015-01-01', '2015-12-31')) {
            this.newsByRange["2015"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2014-01-01', '2014-12-31')) {
            this.newsByRange["2014"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2013-01-01', '1999-12-31')) {
            this.newsByRange["older"].push(news);
          }

        }
      })
    });

  }

  switchNewsByRange(newsRange) {
    this.news = this.newsByRange[newsRange];
  }

  countNewsByRange(newsRange) {
    return this.newsByRange[newsRange].length;
  }
}

export default angular.module('conduuApp.newsArchive', [uiRouter])
  .config(routes)
  .component('newsArchive', {
    template: require('./news-archive.html'),
    controller: NewsArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/archive/news-archive.component.js